// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"67d86f26","353":"40326d2d","649":"2d75f10a","760":"1b8d7dcc"}[chunkId] + ".chunk.css";
};